import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import BaseRound from './BaseRound';
import { useGame } from '../../contexts/GameContext';

const events = [
  {
    text: "Glückwunsch! Du darfst 3 Schlücke verteilen!",
    drinks: 3,
    type: "positive"
  },
  {
    text: "Oh nein! Trink 2 Schlücke!",
    drinks: 2,
    type: "negative"
  },
  {
    text: "Verteile 5 Schlücke!",
    drinks: 5,
    type: "positive"
  },
  {
    text: "Pech gehabt! Ex dein Getränk!",
    drinks: 5,
    type: "negative"
  },
  {
    text: "Alle trinken 1 Schluck!",
    drinks: 1,
    type: "neutral"
  },
  {
    text: "Wähle einen Spieler - ihr trinkt beide 2 Schlücke!",
    drinks: 2,
    type: "neutral"
  },
  {
    text: "Trink 3 Schlücke!",
    drinks: 3,
    type: "negative"
  }
];

const drinkingBuddyEvent = {
  text: (player1, player2) => `${player1} und ${player2} sind jetzt Drinking Buddies! 🍻 Wenn einer trinkt, trinkt der andere mit!`,
  drinks: 1,
  type: "special",
  action: (currentPlayer, players, setDrinkingBuddies) => {
    // Filter out the current player and get a random buddy
    const availablePlayers = players.filter(p => p.name !== currentPlayer);
    const randomBuddy = availablePlayers[Math.floor(Math.random() * availablePlayers.length)];
    setDrinkingBuddies([currentPlayer, randomBuddy.name]);
    return [currentPlayer, randomBuddy.name];
  }
};

export default function RandomEventRound() {
  const [currentEvent, setCurrentEvent] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [drinkingBuddies, setLocalDrinkingBuddies] = useState(null);
  const { state, setDrinkingBuddies } = useGame();

  const handleReveal = () => {
    // 20% chance for drinking buddy event if no drinking buddies exist
    const shouldTriggerDrinkingBuddy = !state.drinkingBuddies && Math.random() < 0.2;
    
    if (shouldTriggerDrinkingBuddy) {
      const buddies = drinkingBuddyEvent.action(
        state.activePlayer,
        state.players,
        setDrinkingBuddies
      );
      setLocalDrinkingBuddies(buddies);
      setCurrentEvent({
        ...drinkingBuddyEvent,
        text: drinkingBuddyEvent.text(buddies[0], buddies[1])
      });
    } else {
      const event = events[Math.floor(Math.random() * events.length)];
      setCurrentEvent(event);
    }
    setShowResult(true);
  };

  const resultData = showResult && currentEvent ? {
    title: currentEvent.type === 'positive' 
      ? '🎉 Glückstreffer!'
      : currentEvent.type === 'negative'
        ? '💀 Pech gehabt!'
        : currentEvent.type === 'special'
          ? '🍻 Drinking Buddies!'
          : '🎲 Ereignis!',
    success: currentEvent.type === 'positive' || currentEvent.type === 'special',
    drinks: currentEvent.drinks,
    player: state.activePlayer,
    points: currentEvent.type === 'positive' ? 1 : 0,
    customText: currentEvent.text
  } : null;

  return (
    <BaseRound
      instructions={`${state.activePlayer}, lass uns sehen, was das Schicksal für dich bereithält!`}
      showResult={showResult}
      resultData={resultData}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {!showResult && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReveal}
            sx={{ 
              py: 3, 
              fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #FF8E53 30%, #FE6B8B 90%)',
              '&:hover': {
                background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
              }
            }}
          >
            Ereignis aufdecken
          </Button>
        )}
      </Box>
    </BaseRound>
  );
} 